
import { computed, defineComponent, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { OpenAccountTypeMap, OpenStatus, RouterName } from '@/enum'
import { isInAppWebview } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { useLazyQuery } from '@vue/apollo-composable'
import { queryApi } from '@/graphql/query'

export type SetpList = {
  [propName: number]: string
}

export default defineComponent({
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const openCommon = computed(() => store.getters.openCommon)

    const stepList: SetpList = {
      1: RouterName.ID_CARD,
      2: RouterName.ID_CARD_INFO,
      3: RouterName.CONTACT_INFO,
      4: RouterName.FINANCIAL_INFO,
      5: RouterName.TAX_INFO,
      6: RouterName.RISK,
      7: RouterName.OTHER,
      8: RouterName.PI,
      9: RouterName.PI_RISK,
      10: RouterName.PI_AR,
      11: RouterName.STATEMENT,
      12: RouterName.CAPTCHA,
      13: RouterName.CONFIRM,
      14: RouterName.TRANSFER_STEP,
      15: RouterName.BIND_CARD,
      16: RouterName.TRANSFER,
      17: RouterName.TRANSFER_PRO,
      18: RouterName.ACCOUNT_TYPE
    }

    const { load: queryOpenStatus, onResult } = useLazyQuery(queryApi.customerOpenStatus)

    onResult((res) => {
      const { customerOpenStatus } = res.data
      if (customerOpenStatus.ok) {
        // 未提交
        if (customerOpenStatus.data.applicationStatus === OpenStatus.NO_SUBMIT) {
          if (isInAppWebview()) {
            const name = stepList[openCommon.value.step]
              ? stepList[openCommon.value.step]
              : RouterName.ID_TYPE
            router.replace({ name, query: { type: route.query.type } })
          } else {
            router.replace({ name: RouterName.STATUS, query: { type: route.query.type } })
          }
        } else if (customerOpenStatus.data.applicationStatus === OpenStatus.OPEN_REJECT) {
          // 驳回
          if (isInAppWebview()) {
            router.replace({ name: RouterName.ID_TYPE, query: { type: route.query.type } })
          } else {
            router.replace({ name: RouterName.STATUS, query: { type: route.query.type } })
          }
        } else if (customerOpenStatus.data.applicationStatus === OpenStatus.SUPPLEMENT) {
          if (isInAppWebview()) {
            router.replace({ name: RouterName.TRANSFER_STEP, query: { type: route.query.type, hide: 1 } })
          } else {
            router.replace({ name: RouterName.STATUS, query: { type: route.query.type, hide: 1 } })
          }
        } else if (customerOpenStatus.data.applicationStatus === OpenStatus.ABOLISH) {
          if (isInAppWebview()) {
            router.replace({ name: RouterName.ID_TYPE, query: { type: route.query.type } })
          } else {
            router.replace({ name: RouterName.STATUS, query: { type: route.query.type } })
          }
        } else {
          router.replace({ name: RouterName.STATUS, query: { type: route.query.type } })
        }
      }
    })

    onMounted(() => {
      console.log('guide')
      const { type } = route.query
      type && storage.set('formType', type)
      queryOpenStatus(queryApi.customerOpenStatus, {
        params: {
          openAccountType: OpenAccountTypeMap[type as string]
        }
      })
    })
  }
})
